module.exports = __webpack_public_path__ + "static/media/SPRAY3.ec7b0ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY3.png
// module id = 285
// module chunks = 0